// extracted by mini-css-extract-plugin
export default {"layout-conatiner":"layout_layout-conatiner__z0bH9","layout-main":"layout_layout-main__6CFyG","overlay":"layout_overlay__7KBMN"};